export enum ColorInputMode {
  HEX = 'hex',
  RGBA = 'rgba',
  HSLA = 'hsla',
}
